/**
 * WALLET -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the wallet module
 */
// eslint-disable-next-line
export const WALLET = {
  SET_BONUS: 'bonus-wallet/setBonus',
  FIND_ALL: 'bonus-wallet/findAll',
  DELETE: 'bonus-wallet/cancelBonus',
  CALCULATE_ROLLOVER: 'transactions/freeplay-rollover',
  SYNC_BETSOFTBONUS: 'bonus-wallet/sync-betsoftbonus',
  GET_BONUS_BALANCE: 'bonus-wallet/getBonusBalance',
}
